/**
 * ConvoCX — Astryx app root (CON-845, shell CON-853).
 * Gates on auth: shows the branded login when there is no session, then mounts
 * the full app shell (side nav + 3-column workspace + routed FR-12.5 pages).
 * Light is the product default (PRD D8); dark is an opt-in override via the
 * top-nav toggle (owned in ThemeRoot).
 */
import { useAuth } from './inbox/auth';
import { LoginGate } from './inbox/LoginGate';
import { Shell } from './shell/AppShell';
import type { ThemeMode } from './inbox/InboxPage';

export type { ThemeMode };

interface AppProps {
  mode: ThemeMode;
  onToggleMode: () => void;
}

export function App({ mode, onToggleMode }: AppProps) {
  const { token } = useAuth();

  if (!token) {
    return <LoginGate />;
  }

  return <Shell mode={mode} onToggleMode={onToggleMode} />;
}